// ログインユーザーアバター用 最初の１文字大文字にして返す
export const AvatarString = (value: string) => {
  return value.substring(0, 1).toUpperCase()
}

// サイトパス用にsite.nameを全て小文字にして返す
export const SitePathString = (value: string) => {
  return value.toLowerCase()
}